module.exports = __webpack_public_path__ + "img/image.00213376.png";